<form
  class="newsletter-subscription"
  (ngSubmit)="onSubmit(emailField)"
  [formGroup]="subscriptionGroup"
  cdkMonitorSubtreeFocus
  [attr.aria-describedby]="hintId"
  (cdkFocusChange)="onFormFocusChange($event)"
>
  <pai-input-field
    class="newsletter-subscription__field"
    #inputField
    [label]="'NewsletterSubscription.Label' | translate"
    theme="bright"
    [class.newsletter-subscription__field--error]="inputField.showError()"
  >
    <input type="email" [formControl]="subscriptionGroup.controls.email" #emailField />

    <button
      type="submit"
      paiRipple
      [paiRippleUnbounded]="true"
      [attr.aria-label]="'NewsletterSubscription.Submit.Label' | translate"
      [attr.title]="'NewsletterSubscription.Submit.Label' | translate"
      [attr.aria-describedby]="hintId"
    >
      <pai-icon icon="arrow-right" aria-hidden="true" />
    </button>
  </pai-input-field>
  <div class="newsletter-subscription__hint" [attr.id]="hintId" #hintElRef tabindex="-1">
    @switch (message()) {
      @case ('success') {
        <p cdkAriaLive="assertive">{{ 'NewsletterSubscription.SuccessMessage' | translate }}</p>
      }
      @case ('requestError') {
        <p cdkAriaLive="assertive">{{ 'NewsletterSubscription.UnknownError' | translate }}</p>
      }
      @case ('hint') {
        <p>{{ 'NewsletterSubscription.Hint' | translate }}</p>
      }
    }
  </div>
</form>
